__webpack_require__.p = "/CymeTechMurphyBed/";